import styled from 'styled-components';
import cssProps from '../../utils/cssProps';
import {
	NAME,
	SCOPE,
	GROUP_ROLE,
	REGION,
	POINT_OF_CONTACT,
	EXTERNAL_USER,
	INTERNAL_USER,
	NOT_USING_CANVAS
} from './utils/constants';

export default styled.div`
	${cssProps}
	padding-top: var(--px-8);
	padding-bottom: var(--px-8);
	display: grid;
	grid-template-columns: 0.5fr 1.5fr auto;
	grid-template-rows: auto;
	gap: var(--gap);
	grid-template-areas:
		${({showInstructional}) => showInstructional && `'instructional instructional instructional'`}
		'name name name'
		'scope scope scope'
		'role region region'
		'pocDetails pocDetails notUsing';

	.instructional {
		grid-area: instructional;
	}

	.${NAME} {
		grid-area: name;
	}

	.${SCOPE} {
		grid-area: scope;
	}

	.${GROUP_ROLE} {
		grid-area: role;
	}

	.${REGION} {
		grid-area: region;
		display: flex;
		flex-flow: column;
		align-self: end;

		.motif-select-input {
			display: block;
		}
	}

	.${POINT_OF_CONTACT} {
		grid-area: poc;
	}

	.${EXTERNAL_USER}, .${INTERNAL_USER} {
		grid-area: pocDetails;
	}

	.${NOT_USING_CANVAS} {
		grid-area: notUsing;
		display: flex;
		align-items: start;
		padding-top: var(--px-14);
		gap: var(--px-7);
		.motif-tooltip-wrapper {
			.motif-tooltip-trigger-wrap {
				.motif-icon {
					display: flex;
				}
			}
		}
	}
`;
